/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import debounce from "lodash/debounce";
import { useEffect, useState } from "react";

import { Device, DEVICE_BP_DESKTOP_MIN, DEVICE_BP_TABLET_MIN } from "~/constants";

const getDevice = () => {
  if (window.innerWidth < DEVICE_BP_TABLET_MIN) {
    return Device.MOBILE;
  }

  if (window.innerWidth < DEVICE_BP_DESKTOP_MIN) {
    return Device.TABLET;
  }

  return Device.DESKTOP;
};

const useDevice = () => {
  const [device, setDevice] = useState<Device>(getDevice);

  useEffect(() => {
    const resizeListener = () => {
      setDevice(getDevice());
    };

    const debouncedListener = debounce(resizeListener, 300, { maxWait: 300 });

    window.addEventListener("resize", debouncedListener);

    return () => {
      debouncedListener.cancel();

      window.removeEventListener("resize", debouncedListener);
    };
  }, []);

  return device;
};

export default useDevice;
